module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home"
  }, [_vm._c('div', {
    staticClass: "banner"
  }, [_vm._c('div', {
    staticClass: "copy"
  }, [_vm._c('h1', {
    staticClass: "x-large-text weight500"
  }, [_vm._v("Better Grades, Less Effort.")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("\n        CLEX helps improve grades by organizing notes to prioritize and focus studying.\n        This simple, easy-to-use software provides a flexible approach to learning.\n      ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "buttons"
  }, [_vm._c('a', {
    staticClass: "btn-pub btn-pub-blank signup-btn fixed-width xs-full-width",
    attrs: {
      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
    }
  }, [_vm._v("Sign Up for Free")]), _vm._v(" "), _vm._c('div', {
    staticClass: "btn-pub btn-pub-primary video-btn fixed-width xs-full-width",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.scrollToVideo
    }
  }, [_vm._v("Watch Our Video")])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "bg"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner6_500.jpg",
      "media": "(max-width: 500px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner6_800.jpg",
      "media": "(min-width: 501px) and (max-width: 767px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner6_1200.jpg",
      "media": "(min-width: 768px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner6_1600.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner6_2000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/home/banner6_1600.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  })], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "container key-features ptb-100"
  }, [_vm._c('div', {
    staticClass: "row text-center xs-mb-50"
  }, [_vm._c('div', {
    staticClass: "col"
  }, [_vm._c('video-player', {
    attrs: {
      "src": "/static/video/demo.mp4",
      "reference": "homeVideo"
    }
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._c('div', {
    staticClass: "wrap-blue banner-with-copy testimonial"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-push-sm-6 col-sm-6 pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner7_400.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner7_600.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner7_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner7_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/home/banner7_800.jpg",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-push-sm-6 col-sm-6"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._c('p', [_vm._v("\n            “As a devoted student of the University of British Columbia I study continuously.\n            CLEX allows me to organize my studies and create micro-notes for each of my courses.\n            By using this method I was able to be more focused, and better prepared for each of my examinations which ultimately improved my grades”\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "name weight500"
  }, [_vm._v("- Billy, University of British Columbia")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'features'
      }
    }
  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('div', {
    staticClass: "bottom-banner"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner8_600.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner8_600.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner8_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/home/banner8_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/home/banner8_800.jpg",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 "
  }, [_vm._c('div', {
    staticClass: "banner-text"
  }, [_vm._c('h2', {
    staticClass: "xs-mb-30 weight500"
  }, [_vm._v("Take the stress out of studying")]), _vm._v(" "), _vm._c('p', {
    staticClass: "xs-mb-30"
  }, [_vm._v("\n            We believe learning should be an engaging and rewarding experience. CLEX is\n            designed with your brain in mind so you can get back to enjoying the subject you’re passionate about!\n          ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank xs-mb-30 fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'features'
      }
    }
  }, [_vm._v("Learn More")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row text-center"
  }, [_vm._c('div', {
    staticClass: "col-sm-4"
  }, [_vm._c('div', {
    staticClass: "feature"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-01.png",
      "alt": "Learn Smarter"
    }
  }), _vm._v(" "), _vm._c('h2', {
    staticClass: "xs-mt-50 xs-mb-30"
  }, [_vm._v("Learn Smarter")])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-4"
  }, [_vm._c('div', {
    staticClass: "feature"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-02.png",
      "alt": "Organize Notes"
    }
  }), _vm._v(" "), _vm._c('h2', {
    staticClass: "xs-mt-50 xs-mb-30"
  }, [_vm._v("Organize Notes")])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-4"
  }, [_vm._c('div', {
    staticClass: "feature"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-03.png",
      "alt": "Remember Everything"
    }
  }), _vm._v(" "), _vm._c('h2', {
    staticClass: "xs-mt-50 xs-mb-30"
  }, [_vm._v("Remember Everything")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "features ptb-80"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [_vm._c('div', {
    staticClass: "text-center"
  }, [_vm._c('div', {
    staticClass: "feature xs-pb-50"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-04.png",
      "alt": "Focus studying"
    }
  }), _vm._v(" "), _vm._c('h3', [_vm._v("Focus studying")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "feature xs-pb-50"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-05.png",
      "alt": "Access everywhere"
    }
  }), _vm._v(" "), _vm._c('h3', [_vm._v("Access everywhere")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "feature xs-pb-50"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-06.png",
      "alt": "Keywords search"
    }
  }), _vm._v(" "), _vm._c('h3', [_vm._v("Keywords search")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "feature xs-pb-50"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-07.png",
      "alt": "Micro-notes"
    }
  }), _vm._v(" "), _vm._c('h3', [_vm._v("Micro-notes")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "feature xs-pb-50"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/home/Homepage_Icons-08.png",
      "alt": "One-click import"
    }
  }), _vm._v(" "), _vm._c('h3', [_vm._v("One-click import")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "row xs-pt-30"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._c('a', {
    staticClass: "btn-pub btn-pub-border-primary fixed-width",
    attrs: {
      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
    }
  }, [_vm._v("Sign Up for Free")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79284055!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomePage.vue
// module id = 688
// module chunks = 1